import { Injectable } from '@angular/core';
import { ClaimTypeCommonService } from './claim-type-common.service';
import { ClaimTypeUSService } from './claim-type-us.service';
import { ClaimTypeAUService } from './claim-type-au.service';
import { ClaimTypeCAService } from './claim-type-ca.service';
import { ClaimTypeNzService } from './claim-type-nz.service';
import { CacheService } from 'src/app/shared/services/cache.service';
import { ClaimTypeGBService } from './claim-type-gb.service';
import { ClaimTypeEsService } from './claim-type-es.service';

@Injectable({
  providedIn: 'root'
})
export class ClaimTypeClientService {
  constructor(private claimTypeUS: ClaimTypeUSService,
    private claimTypeCA: ClaimTypeCAService, private claimTypeAU: ClaimTypeAUService,
    private claimTypeNZ: ClaimTypeNzService, private claimTypeGB:ClaimTypeGBService,
    private claimTypeES: ClaimTypeEsService, private claimCommon: ClaimTypeCommonService,
    private cacheService: CacheService) {


  }

  callService(): any {
    const country = this.cacheService.getCountry();
     if (country === 'us') {
      return this.claimTypeUS.getClaimTypeData();
    } else if (country === 'ca') {
      return this.claimTypeCA.getClaimTypeData();
    } else if (country === 'au') {
      return this.claimTypeAU.getClaimTypeData();
    } else if (country === 'nz') {
      return this.claimTypeNZ.getClaimTypeData();
    } else if (country === 'gb') {
      return this.claimTypeGB.getClaimTypeData();
    } else if (country === 'es' || country === 'pt') {
      return this.claimTypeES.getClaimTypeData();
    } else {
      return this.claimCommon.getClaimTypeData();
    }
  }
}
